import _ from 'lodash'
import moment from 'moment'

export const weekdaysHelper = {
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
}
export const numberToWeekDayHelper = {
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
}
export const daysOfWeek = {
  Monday: 'Mon',
  Tuesday: 'Tue',
  Wednesday: 'Wed',
  Thursday: 'Thu',
  Friday: 'Fri',
}

export const deliveryFrequency = {
  1: 'orderEdit.deliveryFrequency.everyWeek',
  2: 'orderEdit.deliveryFrequency.everyTwoWeeks',
  3: 'orderEdit.deliveryFrequency.everyThreeWeeks',
  4: 'orderEdit.deliveryFrequency.everyFourWeeks',
  5: 'orderEdit.deliveryFrequency.everyFiveWeeks',
  100: 'orderEdit.deliveryFrequency.firstInMonth',
  102: 'orderEdit.deliveryFrequency.lastInMonth',
  103: 'orderEdit.deliveryFrequency.secondWeekOfMonth',
  104: 'orderEdit.deliveryFrequency.thirdWeekOfMonth',
  105: 'orderEdit.deliveryFrequency.fourthWeekOfMonth',
  110: 'orderEdit.deliveryFrequency.onceOnly',
}
export const numberEmployeesList = [
  '0-10',
  '10-20',
  '20-50',
  '50-100',
  '100-150',
  '150-300',
  '300-500',
  '+500',
]
export const industryList = [
  '--None--',
  'Consulting',
  'Education',
  'Energy and Utilities',
  'Entertainment',
  'Financial Services',
  'Media and PR',
  'Charity and Not For Profit',
  'Transport and mobility',
  'Other',
  'Recruitment',
  'Legal',
  'Construction/engineering',
  'Retail and consumer',
  'Pharmaceuticals and healthcare',
  'Public sector',
  'Technology and telecoms',
  'Manufacturing',
  'Real estate',
  'Hospitality and events',
]

export const dbRegionId = ['DEV', 'MID']

const decodeTokenPayload = (token) => {
  try {
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        })
        .join(''),
    )
    return JSON.parse(jsonPayload)
  } catch {
    return null
  }
}

export const getEmailFromToken = () => {
  const token = localStorage.getItem('token')
  if (token) {
    const payload = decodeTokenPayload(token)
    return payload?.email ?? ''
  }
  return ''
}

export const getIsVTigerAdminFromToken = () => {
  const token = localStorage.getItem('token')
  if (!token) return false
  const payload = decodeTokenPayload(token)
  return payload?.isVTigerAdmin === true
}
export const getInvoiceCountriesBySystem = (prefix) => {
  switch (prefix) {
    case 'DEV':
    case 'LON':
      return [
        'United Kingdom',
        'Cyprus',
        'Czech Republic',
        'Ireland',
        'Luxembourg',
        'Poland',
        'Portugal',
        'Scotland',
        'Sweden',
        'Switzerland',
      ]
    case 'MID':
      return ['United Kingdom']
    case 'MAN':
      return ['United Kingdom', 'Poland']
    case 'SCO':
      return ['Scotland', 'Philippines']
    default:
      return []
  }
}
export const getWorkplaceActiveOngoingOrder = (workplace) => {
  let activeOrder = null
  const ongoingOrders = _.get(workplace, 'orders', []).filter((order) => {
    return _.isEmpty(order.EndDate) || order.TrialOrder === '1'
  })
  _.each(ongoingOrders, (order) => {
    if (activeOrder === null) {
      activeOrder = order
    } else {
      const currentEndDate = moment(order.StartDate)
      const activeEndDate = moment(order.StartDate)
      if (currentEndDate.isAfter(activeEndDate)) {
        activeOrder = order
      }
    }
  })
  return activeOrder
}
export const formatPrice = (price) => {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(price)
}

export const shouldDisableWeekDay = (weekDay, orderOperationDetails) => {
  let effectiveDate = _.get(orderOperationDetails, 'effective_date')
  let revertDate = _.get(orderOperationDetails, 'revert_date')
  if (!effectiveDate || !revertDate) {
    return false
  }
  effectiveDate = moment(effectiveDate, 'YYYY-MM-DD')
  revertDate = moment(revertDate, 'YYYY-MM-DD')
  const daysDiff = revertDate.diff(effectiveDate, 'days')
  const weekDays = _.times(daysDiff + 1, (n) =>
    effectiveDate.clone().add(n, 'days').isoWeekday(),
  ).filter((day) => day >= 1 && day <= 5)
  if (weekDays.length >= 5) {
    return false
  }
  const weekDayNumber = weekdaysHelper[weekDay]
  if (!weekDays.includes(weekDayNumber)) {
    return true
  }
  return false
}

export const isHardLocked = (orderLocks, effectiveDate) => {
  const hardLockDate = _.get(orderLocks, 'Result.earliest')
  if (_.isEmpty(hardLockDate)) {
    return true
  }

  const startDate = moment(effectiveDate)
  const earliestDate = moment(hardLockDate)

  // The 'earliest' field represents the earliest date we CAN make changes for
  // So we're locked if the effective date is BEFORE the earliest date
  return startDate.isBefore(earliestDate)
}

// Move validLanguages here for shared use
export const validLanguages = ['uk', 'de', 'nl', 'be', 'lu'] // UK, Germany, Netherlands, Belgium, Luxembourg

/**
 * Detects the region/language code from the current URL.
 * Supports both subdomain (uk.app.com) and TLD (app.com.uk).
 * Returns the code if found, otherwise null.
 */
export const detectRegionFromUrl = () => {
  const parts = window.location.hostname.split('.')

  // Check first element (subdomain, e.g., uk.app.com or uk.localhost)
  // Check last element (TLD, e.g., app.com.uk)

  const first = parts[0]
  const last = parts[parts.length - 1]
  if (first.length === 2 && validLanguages.includes(first)) {
    return first
  }

  if (last.length === 2 && validLanguages.includes(last)) {
    return last
  }
  return null
}

export const startDatePickerMinDate = (orderLocks = {}) => {
  const { earliest } = orderLocks.Result || {}
  if (!earliest) {
    return new Date(moment().format('YYYY-MM-DD'))
  }
  const momentEarliestLock = moment(earliest, 'YYYY-MM-DD')
  return new Date(momentEarliestLock)
}
